export default __webpack_public_path__ + "6871af7868f4556c804e1bc14e58482a.glb";